/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { HTTPValidationError, ProjectSuggestionResponse } from './platformapi.schemas';

import generateOrgProjectSuggestionsMutator from '../custom-axios-instance';
import getProjectSuggestionsMutator from '../custom-axios-instance';
import sendProjectSuggestEmailMutator from '../custom-axios-instance';

/**
 * @summary Generate Org Project Suggestions
 */
export const generateOrgProjectSuggestions = (organizationId: number, signal?: AbortSignal) => {
  return generateOrgProjectSuggestionsMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/project-suggestions/create-project-suggestions/${organizationId}`,
    method: 'POST',
    signal,
  });
};

export const getGenerateOrgProjectSuggestionsMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateOrgProjectSuggestions>>,
    TError,
    { organizationId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateOrgProjectSuggestions>>,
  TError,
  { organizationId: number },
  TContext
> => {
  const mutationKey = ['generateOrgProjectSuggestions'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateOrgProjectSuggestions>>,
    { organizationId: number }
  > = (props) => {
    const { organizationId } = props ?? {};

    return generateOrgProjectSuggestions(organizationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateOrgProjectSuggestionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateOrgProjectSuggestions>>
>;

export type GenerateOrgProjectSuggestionsMutationError = void | HTTPValidationError;

/**
 * @summary Generate Org Project Suggestions
 */
export const useGenerateOrgProjectSuggestions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generateOrgProjectSuggestions>>,
      TError,
      { organizationId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generateOrgProjectSuggestions>>,
  TError,
  { organizationId: number },
  TContext
> => {
  const mutationOptions = getGenerateOrgProjectSuggestionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Retrieve 3 most recent project suggestions for a given organization.
 * @summary Get Project Suggestions
 */
export const getProjectSuggestions = (organizationId: number, signal?: AbortSignal) => {
  return getProjectSuggestionsMutator<ProjectSuggestionResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/project-suggestions/project-suggestions/${organizationId}`,
    method: 'GET',
    signal,
  });
};

export const getGetProjectSuggestionsQueryKey = (organizationId: number) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/project-suggestions/project-suggestions/${organizationId}`,
  ] as const;
};

export const getGetProjectSuggestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getProjectSuggestions>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectSuggestions>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectSuggestionsQueryKey(organizationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProjectSuggestions>>> = ({ signal }) =>
    getProjectSuggestions(organizationId, signal);

  return { queryKey, queryFn, enabled: !!organizationId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProjectSuggestions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetProjectSuggestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProjectSuggestions>>
>;
export type GetProjectSuggestionsQueryError = void | HTTPValidationError;

export function useGetProjectSuggestions<
  TData = Awaited<ReturnType<typeof getProjectSuggestions>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectSuggestions>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectSuggestions>>,
          TError,
          Awaited<ReturnType<typeof getProjectSuggestions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProjectSuggestions<
  TData = Awaited<ReturnType<typeof getProjectSuggestions>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectSuggestions>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProjectSuggestions>>,
          TError,
          Awaited<ReturnType<typeof getProjectSuggestions>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProjectSuggestions<
  TData = Awaited<ReturnType<typeof getProjectSuggestions>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectSuggestions>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Project Suggestions
 */

export function useGetProjectSuggestions<
  TData = Awaited<ReturnType<typeof getProjectSuggestions>>,
  TError = void | HTTPValidationError,
>(
  organizationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProjectSuggestions>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetProjectSuggestionsQueryOptions(organizationId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Sends the project suggestion email template to the most recent org rep associated with the suggested project organization
 * @summary Send Project Suggest Email
 */
export const sendProjectSuggestEmail = (suggestedProjectId: number, signal?: AbortSignal) => {
  return sendProjectSuggestEmailMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/project-suggestions/send-project-suggest-email/${suggestedProjectId}`,
    method: 'POST',
    signal,
  });
};

export const getSendProjectSuggestEmailMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendProjectSuggestEmail>>,
    TError,
    { suggestedProjectId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendProjectSuggestEmail>>,
  TError,
  { suggestedProjectId: number },
  TContext
> => {
  const mutationKey = ['sendProjectSuggestEmail'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendProjectSuggestEmail>>,
    { suggestedProjectId: number }
  > = (props) => {
    const { suggestedProjectId } = props ?? {};

    return sendProjectSuggestEmail(suggestedProjectId);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendProjectSuggestEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendProjectSuggestEmail>>
>;

export type SendProjectSuggestEmailMutationError = void | HTTPValidationError;

/**
 * @summary Send Project Suggest Email
 */
export const useSendProjectSuggestEmail = <TError = void | HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendProjectSuggestEmail>>,
      TError,
      { suggestedProjectId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendProjectSuggestEmail>>,
  TError,
  { suggestedProjectId: number },
  TContext
> => {
  const mutationOptions = getSendProjectSuggestEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
